import {Context, createContext, ReactNode, useContext, useEffect, useState} from "react";
import {IGrpCmpEdt} from "../Interfaces/IGrpCmpEdt";

type TValue = {
    showOld: boolean,
    setShowOld: (value: boolean) => void,
    groups: IGrpCmpEdt[],
    setGroups: (value: IGrpCmpEdt[]) => void,
    selectedMatchDays: string[],
    setSelectedMatchDays: (value: string[]) => void,
    filteredMatches: string,
    setFilteredMatches: (value: string) => void,
    currentCmpEdt: number,
    setCurrentCmpEdt: (value: number) => void,
    hasGroups: boolean,
    setHasGroups: (value: boolean) => void,
    selectedGroupIds: number[],
    setSelectedGroupIds: (value: number[]) => void,
}

const DValue: TValue = {
    showOld: false,
    setShowOld: () => {},
    groups: [],
    setGroups: () => {},
    selectedMatchDays: [],
    setSelectedMatchDays: () => {},
    filteredMatches: "",
    setFilteredMatches: () => {},
    currentCmpEdt: 0,
    setCurrentCmpEdt: () => {},
    hasGroups: false,
    setHasGroups: () => {},
    selectedGroupIds: [],
    setSelectedGroupIds: () => {},
}

const GlobalContext: Context<TValue> = createContext(DValue);

export function useGlobal(): TValue {
    return useContext(GlobalContext);
}

export function GlobalProvider({children}: { children: ReactNode }) {
    const [showOld, setShowOld] = useState(false);
    const [groups, setGroups] = useState<IGrpCmpEdt[]>([]);
    const [selectedMatchDays, setSelectedMatchDays] = useState<string[]>([]);
    const [filteredMatches, setFilteredMatches] = useState<string>("");
    const [currentCmpEdt, setCurrentCmpEdt] = useState<number>(0);
    const [hasGroups, setHasGroups] = useState<boolean>(false);
    const [selectedGroupIds, setSelectedGroupIds] = useState<number[]>([]);

    useEffect(() => {
        setSelectedGroupIds(groups.map(g => g.Idt));
    }, [groups]);

    const value: TValue = {
        showOld, setShowOld,
        groups, setGroups,
        selectedMatchDays, setSelectedMatchDays,
        filteredMatches, setFilteredMatches,
        currentCmpEdt, setCurrentCmpEdt,
        hasGroups, setHasGroups,
        selectedGroupIds, setSelectedGroupIds,
    };

    return (
        <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>
    )
}
